import React from 'react';
import styles from './Applied.module.css'

const Applied = () => {
    return (
        <>
            <div className={styles.appliedContainer}>
                <div className={styles.headerContainer}>
                    <div className={styles.CheckIcon}></div>
                    <h1 className={styles.header}>
                        Thank You
                    </h1>
                    <h2 className={styles.description}>
                        Information is submited and secured with us . our team will contact you by email or phone
                    </h2>
                </div>
            </div>
        </>
    );
};

export default Applied;
